module.exports = __webpack_public_path__ + "img/맞춤형서비스제공.c4ededa8.png";